import { useState } from "react";
import DOMPurify from "dompurify";
import axios from "axios";

const statusColor = (status) => {
    if (status == "Pending") return "bg-gray-400";
    return "bg-green-500";
};

const TransactionTimeline = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [trxCode, setTrxCode] = useState(null);

    const [timelineData, setTimelineData] = useState([]);
    
    const fetchData = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/tracking/timeline?trx_code=${trxCode}`, {});

            setTimelineData(response.data);

        } catch (error) {
            console.error('Gagal mengambil data perusahaan:', error);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <div className="max-w-3xl mx-auto">

                {/* Header */}
                <h1 className="text-2xl font-bold mb-6 text-center">
                    Timeline Draft
                </h1>

                {/* Input */}
                <div className="bg-white rounded-xl shadow p-4 mb-6 flex gap-3">
                    <input
                        type="text"
                        placeholder="Enter Transaction Code..."
                        value={trxCode}
                        onChange={(e) => setTrxCode(e.target.value)}
                        className="flex-1 border rounded-lg px-4 py-2 outline-none focus:ring-2 focus:ring-blue-400"
                    />
                    <button onClick={() => fetchData()} className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition">
                        Load
                    </button>
                </div>

                {/* Timeline */}
                <div className="bg-white rounded-xl shadow p-6">
                    {timelineData?.map((item, index) => (
                        <div key={index} className="flex gap-4 relative">
                            {/* Line */}
                            {index !== timelineData.length - 1 && (
                                <div className="absolute left-3 top-8 w-[2px] h-full bg-gray-200"></div>
                            )}
                            {/* Dot */}
                            <div className={`w-6 h-6 rounded-full ${statusColor(item.status)} flex-shrink-0 mt-1 shadow`} />
                            {/* Content */}
                            <div className="pb-8 w-full">
                                {/* Header Row */}
                                <div className="flex items-center justify-between">
                                    <div
                                        className="font-semibold text-sm"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(item.step),
                                        }}
                                    />
                                    <span className={`text-xs text-white px-2 py-1 rounded ${statusColor(item.status)}`}>
                                        {item.status}
                                    </span>
                                </div>
                                {/* Date */}
                                <div className="text-xs text-gray-500 mt-1">
                                    {item.date}
                                </div>
                                {/* Notes */}
                                {item.notes && (
                                    <div
                                        className="text-xs mt-2 bg-gray-50 p-2 rounded border"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(item.notes),
                                        }}
                                    />
                                )}
                                
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
}

export default TransactionTimeline;
